import styled from 'styled-components'
import { MediumText } from 'components/common/text'

export const PositionFormSubInfoTitleText = styled(MediumText)`
  color: ${(p) => p.theme.color.gray1};
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: ${(p) => p.theme.fontSize.small};
  }
`
